import { Button } from '@bluebeam/react-skyline-button';
import { RichTranslator, useTranslator } from '@bluebeam/react-i18n';
import * as React from 'react';
import './TrialBanner.css';
import './FreshStartSubscriptionBanner.css';
import { AppRegion } from 'constants/appRegion';
import { getAppRegion } from 'utils/getAppRegion';

const FreshStartSubscriptionBanner: React.FC = () => {
  const { translate } = useTranslator(['freshStartSubscriptionBanner']);

  const BuyNowButtonClicked = () => {
    window.open(process.env.BB_SUBSCRIPTION_PATH, '_blank');
  };

  const tryItForFreeButtonClicked = () => {
    switch (getAppRegion()) {
      case AppRegion.AU:
        window.open(process.env.AU_TRIAL_URL, '_blank');
        break;
      case AppRegion.DE:
        window.open(process.env.DE_TRIAL_URL, '_blank');
        break;
      case AppRegion.SE:
        window.open(process.env.SE_TRIAL_URL, '_blank');
        break;
      case AppRegion.UK:
        window.open(process.env.UK_TRIAL_URL, '_blank');
        break;
      default:
        window.open(process.env.US_TRIAL_URL, '_blank');
        break;
    }
  };

  return (
    <div className="fresh-start-sbcrp-banner row justify-center items-center w100 bb-2 bgd-light-grey-2 size-16">
      <span>
        <RichTranslator
          components={[]}
          variables={{
            trialDays: 14,
          }}
          translationKey="freshStartSubscriptionBanner:freshStartContent"
        />
      </span>

      <Button
        className="ml4"
        size="32px"
        variant="filled"
        onClick={tryItForFreeButtonClicked}
      >
        {translate('freshStartSubscriptionBanner:tryItFree')}
      </Button>
      <Button
        className="ml4"
        size="32px"
        variant="outline"
        onClick={BuyNowButtonClicked}
      >
        {translate('freshStartSubscriptionBanner:buyNow')}
      </Button>
    </div>
  );
};

export default FreshStartSubscriptionBanner;
